<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择销售订单"
      width="800px"
      top="5vh"
  >
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="sapBoms"
        @select="selectBom">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号号"/>
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料编号称"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="quantity" slot-scope="scope">
        <el-input-number v-model="scope.row.quantity"/>
      </template>
    </table-select>
    <el-dialog
        width="25%"
        title="请输入数量"
        :visible.sync="innerVisible"
        append-to-body>
      <el-form ref="form" :inline="true" :model="model">
        <el-form-item label="数量" prop="quantity">
          <el-input-number v-model="model.quantity" placeholder="请输入数量"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBom()">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        innerVisible: false,
        filter: {
          materialNo: "",
          materialName: "",
          bomType:"5",
        },
        model: {
          materialNo: "",
          materialName: "",
          quantity: "",
        },
        columns: [
          // {
          //   title: "BOM编号",
          //   key: "bomNo",
          //   width: 140,
          //   align: "center",
          // },
          {
            title: "物料编号",
            key: "materialNo",
            width: 140,
            align: "center",
          },

          {
            title: "物料编号",
            key: "materialName",
            align: "center",
          },
          // {
          //   title: "订单数量",
          //   key: "quantity",
          //   width: 140,
          //   align: "center",
          // },
          // {
          //   title: "BOM类型",
          //   key: "bomTypeName",
          //   width: 140,
          //   align: "center",
          // },

          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "left",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },


      selectBom(row) {
        this.innerVisible = true;
        this.model = row;
      },
      confirmBom() {
        this.innerVisible = false;
        // console.log(this.model);
        this.dialogVisible = false;
        this.$emit("select", this.model);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
